import { Component, Inject, Input, OnInit } from "@angular/core";
import { L10N_LOCALE, L10nLocale } from "angular-l10n";
import { DoctorService } from "src/app/core/services/doctors.service";
import { MessageBusService } from "src/app/core/services/message-bus.service";
import { LicenciaProfesional } from "src/app/core/services/prints.service";
import { LicenseDoctor } from "src/app/shared/models/clinic-history/license-doctor.model";

@Component({
  selector: 'app-career-path-licenses',
  templateUrl: './career-path-licenses.component.html',
  styleUrls: ['./career-path-licenses.component.css']
})
export class CareerPathLicenseComponent implements OnInit  {

    @Input() responsableServicio: number;

    licencia = '';
    licencias: any[] = [];
    isLicenseListValid = false;

    constructor(
        @Inject(L10N_LOCALE) public locale: L10nLocale,
        private doctorService: DoctorService,
        private messageService: MessageBusService
    ) {}

    ngOnInit(): void {
        this.doctorService.getLicense(this.responsableServicio).subscribe(licenseDoctor => this.processLicenses(licenseDoctor));
    }

    private processLicenses(licenseDoctor: LicenseDoctor) {
        const id = licenseDoctor.informacionResponsableServicio.idDocumentoImagenFirma;
        const licencia = this.getLicenseById(licenseDoctor, id);
    
        this.licencia = this.formatLicenseText(licencia);
        this.messageService.setIsVerifiedDoctor({
            isVerified: 'S' == licenseDoctor.informacionResponsableServicio.profesionalVerificado,
            license: this.licencia
        });

        this.licencias = licenseDoctor.licenciasProfesional.map(x => JSON.parse(x.jsonIdentificacion));

        this.isLicenseListValid = this.validateLicenseList();
    }

    private getLicenseById(licenseDoctor: LicenseDoctor, id: number): LicenciaProfesional {
        const licencia = licenseDoctor.licenciasProfesional.find(x => x.idDocumento == id)?.jsonIdentificacion;

        return JSON.parse(licencia ?? licenseDoctor.documentosFirma.find(x => x.idDocumento == id)?.jsonIdentificacion ?? '{}');
    }

    private formatLicenseText(licencia: LicenciaProfesional): string {
        let parts: string[] = [];

        if (!!licencia) {
            const fields: (keyof LicenciaProfesional)[] = ['Registro', 'Codigo', 'Folio'];
            const fieldLabels: Record<string, string> = { Registro: 'Reg.', Codigo: 'Cód.', Folio: 'Folio' };
            
            parts = fields.map(key => licencia[key] ? `${fieldLabels[key]} ${licencia[key]} ` : '').filter(Boolean);
        }

        return parts.join(' ');
    }

    private validateLicenseList() {
        return this.licencias.some(x => [x.Nombre, x.Especialidad, x.Registro, x.Codigo, x.Folio, x.TipoLicencia].some(y => !!y));
    }

}